import { defineMessages } from 'react-intl';

export const billingMessages = defineMessages({
    billingEntities: {
        id: 'billing-entities',
        defaultMessage: 'Billing entities',
    },
    billingEntity: {
        id: 'billing-entity',
        defaultMessage: 'Billing entity',
    },
    legalNumber: {
        id: 'legal-number',
        defaultMessage: 'Legal number',
    },
    taxNumber: {
        id: 'tax-number',
        defaultMessage: 'Tax number',
    },
    tenant: {
        id: 'tenant',
        defaultMessage: 'Tenant',
    },
    editBillingEntitySubtitle: {
        id: 'edit-billing-entity-subtitle',
        defaultMessage: 'Edit billing entity {entity}',
    },
    updateBillingEntitySuccess: {
        id: 'update-billing-entity-success',
        defaultMessage: 'Billing entity updated',
    },
    updateBillingEntitySuccessDescription: {
        id: 'update-billing-entity-success-description',
        defaultMessage: 'Billing entity {entity} has been successfully updated.',
    },
    code: {
        id: 'code',
        defaultMessage: 'Code',
    },
});
